module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-13-af9245e8de8646b7e8fbcad7c60b1540.jpg";